import { render, staticRenderFns } from "./FieldChoiceDetail.vue?vue&type=template&id=749ac604&scoped=true"
import script from "./FieldChoiceDetail.vue?vue&type=script&lang=js"
export * from "./FieldChoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./FieldChoiceDetail.vue?vue&type=style&index=0&id=749ac604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749ac604",
  null
  
)

export default component.exports